import axios from "axios"
import {doLogout} from "./userService";
import {auth} from "./firebase";
import {AUTH_ERROR_EVENT} from "../components/AuthErrorToaster";

// Tempo pro toast de sessão expirada ser lido antes do logout (que recarrega
// a página).
const LOGOUT_DELAY_MS = 3500
let logoutScheduled = false

const notifyAuthError = (status) => {
    window.dispatchEvent(new CustomEvent(AUTH_ERROR_EVENT, { detail: { status } }))
}

const getInstance = () => {
    const _axios = axios.create()

    // getIdToken() renova o token quando está perto de vencer — o
    // auth.currentUser.accessToken lido direto podia estar vencido (dura 1h)
    // e virava 401 à toa nas rotas que exigem login.
    _axios.interceptors.request.use(async function (config) {
        const token = auth.currentUser ? await auth.currentUser.getIdToken() : ""
        config.headers.Authorization = "Bearer " + token
        return config
    })

    _axios.interceptors.response.use(function (response) {
        return response
    }, error => {
        const status = error.response && error.response.status
        if (status === 401) {
            notifyAuthError(401)
            if (!logoutScheduled) {
                logoutScheduled = true
                setTimeout(() => doLogout(), LOGOUT_DELAY_MS)
            }
        } else if (status === 403) {
            notifyAuthError(403)
        }
        // Propaga o erro (antes o 401 devolvia {} e quem chamou tratava como
        // sucesso — ex.: "Alterações Salvas" sem ter salvo).
        throw error
    })

    return _axios
}

const api = {}

api.post = (uri, data, params) => getInstance().post(uri, data, params)

api.get = (uri, params) => getInstance().get(uri, params)

api.delete = (uri) => getInstance().delete(uri)

api.put = (uri, data) => getInstance().put(uri, data)

export default api
